/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-warning': {
    width: 4,
    height: 9,
    viewBox: '0 0 4 9',
    data: '<defs><path pid="0" d="M2.25 5.745v1.5H.75v-1.5h1.5zM.5.755l2 .008-.506 3.992h-.988L.5.755z" id="svgicon-icon-warning-a"/></defs><use _fill="#515151" xlink:href="#svgicon-icon-warning-a" transform="translate(.5 .052)" fill-rule="evenodd"/>'
  }
})
